export const SET_REPORT = 'SETTING/SET_REPORT'
export const SET_REPORTS = 'SETTING/SET_REPORTS'
